import translates from './ms.json';
import restNotifications from './notifiers.json';

export default {
  ms: { ...translates, ...restNotifications },
};
